import { ProgramWizardLookupsManager } from '../../services/ProgramWizardLookupsManager';
import { useProgramDependentDataContext } from '@/app/core/components/program-wizard/program-dependent-data-context';
import { ReactNode, useState, Fragment } from 'react';

interface LookupsFetcherProps {
  subCode: string;
  onSuccess: (
    lookupsManager: ProgramWizardLookupsManager,
    isLoading: boolean,
  ) => ReactNode;
  onError: (error: Error) => void;
}

export const LookupsFetcher = (props: LookupsFetcherProps) => {
  const [isLoading] = useState(false);
  const { onSuccess: onSuccessResponse } = props;
  const { data } = useProgramDependentDataContext();

  return (
    <Fragment>
      {onSuccessResponse(
        data
          ? (data.lookupsManager as ProgramWizardLookupsManager)
          : ProgramWizardLookupsManager.empty(),
        isLoading,
      )}
    </Fragment>
  );
};
